import { render, staticRenderFns } from "./uploadkpi.vue?vue&type=template&id=7aba10b6"
import script from "./uploadkpi.vue?vue&type=script&lang=js"
export * from "./uploadkpi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports